import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { getForumCategoriesApi } from "@/services/userApi";
import { useState, useEffect } from "react";

const BlogPostPreview = ({ previewPosts }) => {

  const defaultIconUrl = "/images/generator-icon/text-voice.png";
  return (
    <>
      {previewPosts.map((post, index) => (
        <div key={post.id} className="forum-category-card">
          <Link href={`/blog/${post.id}`} className="category-link">
            <div className="category-content">
              <div className="category-icon">
                <Image
                  src={post.image}
                  width={50}
                  height={50}
                  alt={post.title}
                />
              </div>
              <div className="category-info">
                <h3 className="category-title">{post.title}</h3>
                <p className="category-description">{post.description}</p>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </>
  );
};

export default BlogPostPreview;